import * as React from "react";

const QuoteLeft = ({ size = '80' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // width="80"
    // height="69"
    width={size}
    height={size * 0.8625}
    fill="none"
    viewBox="0 0 80 69"
  >
    <path
      fill="#333"
      d="M52.207 34.18h12.207v9.765c0 5.387-4.38 9.766-9.766 9.766h-1.22a3.653 3.653 0 0 0-3.662 3.662v7.324a3.653 3.653 0 0 0 3.662 3.662h1.22c13.49 0 24.414-10.925 24.414-24.414V7.325A7.326 7.326 0 0 0 71.739 0H52.207a7.326 7.326 0 0 0-7.324 7.324v19.532a7.326 7.326 0 0 0 7.324 7.324M8.262 34.18h12.207v9.765c0 5.387-4.38 9.766-9.766 9.766h-1.22a3.653 3.653 0 0 0-3.663 3.662v7.324a3.653 3.653 0 0 0 3.662 3.662h1.221c13.489 0 24.414-10.925 24.414-24.414V7.325A7.326 7.326 0 0 0 27.793 0H8.262A7.326 7.326 0 0 0 .938 7.324v19.532a7.326 7.326 0 0 0 7.324 7.324"
    ></path>
  </svg>
);

export default QuoteLeft;
